import { Http } from '@/shared/api/api';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { profileStore } from './profile';

const availableLang = ['kr', 'en', 'vi'];

export const regionStore = defineStore('region', () => {
  const lang = ref('en');

  const setLang = async () => {
    const user = profileStore();
    if (user.profile.memberIdx && user.profile.lang && availableLang.includes(user.profile.lang)) {
      lang.value = user.profile.lang;
      console.log('setLang', lang.value);
      return lang.value;
    }
    Http.api()
      .get('/common/region')
      .then((res) => {
        if (res && res.data) {
          const resultIsoCode = res.data.isoCode === 'VN' ? 'vi' : res.data.isoCode.toLowerCase();
          lang.value = availableLang.includes(resultIsoCode) ? resultIsoCode : 'en';
        }
      });
  };

  return { lang, setLang };
});
